import store from './_store.js'
import * as helpers from './helpers.js'
import entries from 'lodash/entries'
import { Howl } from 'howler'

// use html5 for these
const HTML5_AUDIO = new Set(['point_to_point']);

// fade to zero, then stop
function fadeOut(key, duration=2000, id) {
    const howl = key instanceof Howl ? key : store.get('music')[key];
    if (howl && !howl.playing()) return;

    //console.time(key);
    requestAnimationFrame(() => {
        howl.once('fade', i => howl.stop(i))
            //.once('stop', i => console.timeEnd(key))
            .fade(howl.volume(), 0, duration, id);
    });
}

// fade in and play
function fadeIn(key, volume=.25, duration=200) {
    // set default volume once fade is complete,
    // so fadeOut starts at the correct level
    const howl = key instanceof Howl ? key : store.get('music')[key];

    if (howl && howl.playing()) return;

    requestAnimationFrame(() => {
        howl.once('fade', i => howl.volume(volume))
            .seek(0)
            .fade(howl.volume(), volume, duration)
            .play();
    });
}

// fade out any current music
function fadeAll(duration=2000) {
    store.get('playing').forEach(howl => {
        fadeOut(howl);
    });
}

// pause all playing music, but don't stop
function pauseAll() {
    store.get('playing').forEach(howl => {
        howl.pause();
    });
}

// play currently paused music
function playAll() {
    store.get('playing').forEach(howl => {
        if (!howl.playing()) howl.play();
    });
}

// build howls from gdoc
store.compute('music', ['music_files', 'current_chapter'], (files, current_chapter) => {
    const music = {};
    const chapter_files = files ? files[current_chapter] : [];
    entries(chapter_files).forEach(([key, path]) => {
        const howl = music[key] = new Howl({
            src: [helpers.music(path)],
            loop: true,
            volume: 0,
            html5: window.isMobile.any,

            onplay() {
                const playing = store.get('playing');
                playing.add(howl);
                store.set({ playing });
            },

            onstop() {
                const playing = store.get('playing');
                playing.delete(howl);
                store.set({ playing });
            }
        });
    });

    return music;
});

// always play the right song
store.observe('current_slide', (current, prev) => {

    // todo: move cover into slides
    const { slides, music, current_slide, index_active } = store.get();
    const slide = slides[current_slide];

    if (index_active) return fadeAll();

    Object.keys(music).forEach(key => {

        if (key === slide.music) {
            fadeIn(key);
        } else {
            fadeOut(key);
        }
    });
}, {init: false});


store.observe('index_active', index_active => {

    const { current_slide, slides, music } = store.get();
    const slide = slides[current_slide];

    fadeAll(); // regardless, fade all
    if (index_active) {
        //fadeAll();
        music.river && fadeIn(music.river);
    } else {
        //fadeAll();
        slide && slide.music && fadeIn(slide.music);
        //music.cover && fadeOut(music.cover);
    }
});

// pause on mobile if visibility changes
if (window.isMobile.any) {
    document.addEventListener('visibilitychange', e => {
        if (document.visibilityState === 'visible') {
            playAll();
        } else {
            pauseAll();
        }
    });
}

// for debugging
/*
store.observe('playing', playing => {
    console.log(playing);
});
*/
export { 
    fadeIn, 
    fadeOut, 
    fadeAll, 
    pauseAll, 
    playAll,
}